// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { AdBannerVersion } from './AdBanner.contracts';
import { AdBannerGoogle } from './versions/AdBannerGoogle.ui';
import { AdBannerWTG } from './versions/AdBannerWTG.ui';
const adBannerVersionUiComponentRegistry = {
    [AdBannerVersion.GoogleAds]: AdBannerGoogle,
    [AdBannerVersion.WayToGrow]: AdBannerWTG
};
/**
 * Component capable of rendering the `AdBannerModule's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let AdBannerModuleUi = class AdBannerModuleUi extends AbstractModuleUi {
    get bannerComponent() {
        if (!(this.module.version in adBannerVersionUiComponentRegistry)) {
            this.onError(`AdBannerModule.[get]component(): There's no UI component for the given module version!\nFull [this.module] object: ${JSON.stringify(this.module)}`);
            return AdBannerGoogle;
        }
        return adBannerVersionUiComponentRegistry[this.module.version];
    }
};
__decorate([
    Prop({
        type: Function,
        required: false
    })
], AdBannerModuleUi.prototype, "onEmptyCallback", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], AdBannerModuleUi.prototype, "forceHide", void 0);
AdBannerModuleUi = __decorate([
    Component({
        name: 'AdBannerModuleUi',
        components: { AdBannerGoogle, AdBannerWTG },
        template: `
    <component :is="bannerComponent" v-bind="$props" />
  `
    })
], AdBannerModuleUi);
export { AdBannerModuleUi };
